module.exports = __webpack_public_path__ + "img/hand-coin-fill.e3efc2ef.svg";